var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResearchProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9919 78.6117L0.999985 64.981V14.6309L31.9919 28.2659V78.6117Z",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9836 14.6309L31.9918 28.2659V78.6117L48.4707 71.3621",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999985 14.6307L31.9919 1L62.9837 14.6307",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9918 78.6117L0.999878 64.981V14.6309L31.9918 28.2659V78.6117Z",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9835 43.0139V14.6309L31.9916 28.2659V78.6117",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999893 14.6307L31.9918 1L62.9836 14.6307",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5431 62.0918L4.34032 59.3638",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4941 61.2188L4.34032 55.8721",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8968 58.002C18.8968 58.002 21.6182 62.9951 18.0088 65.7229",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9836 21.4482L31.9917 35.0789",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999985 21.4482L31.9919 35.0789",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1937 50.6387H58.7687C57.9381 50.6387 57.2622 49.971 57.2622 49.1504C57.2622 48.3299 57.9381 47.6621 58.7687 47.6621H67.1937C68.0243 47.6621 68.7002 48.3299 68.7002 49.1504C68.7047 49.971 68.0287 50.6387 67.1937 50.6387Z",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9838 73.9632C61.0045 73.9632 59.4052 72.3789 59.4052 70.4279V50.6387H66.5667V70.4279C66.5623 72.3789 64.963 73.9632 62.9838 73.9632Z",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4052 58.626H66.5623",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2501 61.2273C65.9772 61.2273 66.5666 60.6449 66.5666 59.9266C66.5666 59.2083 65.9772 58.626 65.2501 58.626C64.523 58.626 63.9335 59.2083 63.9335 59.9266C63.9335 60.6449 64.523 61.2273 65.2501 61.2273Z",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0709 72.4094C61.798 72.4094 62.3875 71.8271 62.3875 71.1087C62.3875 70.3904 61.798 69.8081 61.0709 69.8081C60.3438 69.8081 59.7544 70.3904 59.7544 71.1087C59.7544 71.8271 60.3438 72.4094 61.0709 72.4094Z",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4018 65.5487C62.3094 65.5487 63.0452 64.8217 63.0452 63.925C63.0452 63.0282 62.3094 62.3013 61.4018 62.3013C60.4941 62.3013 59.7583 63.0282 59.7583 63.925C59.7583 64.8217 60.4941 65.5487 61.4018 65.5487Z",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9836 78.6114C72.9338 78.6114 81 70.6426 81 60.8126C81 50.9825 72.9338 43.0137 62.9836 43.0137C53.0335 43.0137 44.9673 50.9825 44.9673 60.8126C44.9673 70.6426 53.0335 78.6114 62.9836 78.6114Z",
    stroke: "#161616",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchProduct);
export default __webpack_public_path__ + "static/media/research_product.aa47ec7672b9e5d55b4f46f024de0d54.svg";
export { ForwardRef as ReactComponent };